// @mui
import { makeStyles } from '@mui/styles';

export const priceStyle = (theme) => ({
  root: {}
});

export const usePriceStyle = makeStyles(priceStyle);
